module.exports = __webpack_public_path__ + "static/media/ic_video_call_on.68553aec.png";